import React from 'react'

function TermsConditions() {
  return (
    <div>TermsConditions</div>
  )
}

export default TermsConditions